module.exports = __webpack_public_path__ + "static/maybe-you-should-talk-to-someone-93a8c551579ceea31b4f58dab8101f98.jpg";